const isBrowser = typeof window !== 'undefined';

export const localStorage = {
  get<T>(key: string): T | null {
    if (!isBrowser) return null;
    const item = window.localStorage.getItem(key);
    if (!item) return null;

    try {
      return JSON.parse(item) as T;
    } catch {
      //console.error(`[storage.get] JSON parse error: key=${key}`);
      return null;
    }
  },

  contains(key: string): boolean {
    if (!isBrowser) return false;
    const item = window.localStorage.getItem(key);
    return !!item;
  },

  set<T>(key: string, value: T): void {
    if (!isBrowser) return;
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      //console.error(`[storage.set] error: key=${key}`, e);
    }
  },

  remove(key: string): void {
    if (!isBrowser) return;
    window.localStorage.removeItem(key);
  },

  clear(): void {
    if (!isBrowser) return;
    window.localStorage.clear();
  },
};
